import {
  Operator,
  REGEXP_DECIMAL,
} from '../../../../../../../../services/common/Constants';
import i18next from 'i18next';
import React from 'react';
import EqualValue from './EqualValue';
import ComparisonValue from './ComparisonValue';
import SetValue from './SetValue';

const DeviseFormValue = ({
  selectedOperator,
  availableValueOptions,
  showLabel,
  fieldName,
  readOnly = false
}) => {
  const validateValue = (value) => {
    return value && !value.match(REGEXP_DECIMAL)
      ? i18next.t('attributes.errors.decimal')
      : null;
  };

  switch (selectedOperator) {
    case Operator.EQUAL:
    case Operator.NOT_EQUAL:
      return (
        <EqualValue
          availableValueOptions={availableValueOptions}
          showLabel={showLabel}
          fieldName={fieldName}
          validateValue={validateValue}
          readOnly={readOnly}
        />
      );

    case Operator.GREATER_THAN:
    case Operator.GREATER_OR_EQUAL:
    case Operator.LESS_THAN:
    case Operator.LESS_OR_EQUAL:
      return (
        <ComparisonValue
          validateValue={validateValue}
          showLabel={showLabel}
          fieldName={fieldName}
          readOnly={readOnly}
        />
      );

    case Operator.BETWEEN:
      return <>{/*TODO: Two values*/}</>;

    case Operator.IS_NULL:
    case Operator.NOT_NULL:
      return <>{/*MEANS UNDEFINED*/}</>;

    case Operator.IN_SET:
    case Operator.NOT_IN_SET:
      return (
        <SetValue
          showLabel={showLabel}
          fieldName={fieldName}
          validateValue={validateValue}
          availableValueOptions={availableValueOptions}
          readOnly={readOnly}
        />
      );

    default:
      return <></>;
  }
};

export default DeviseFormValue;
